var _defs, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _circle4, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _circle5, _rect15, _rect16, _ellipse, _rect17, _ellipse2, _rect18, _ellipse3, _text, _rect19, _rect20, _rect21, _rect22, _rect23, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 360",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e40af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fp-card",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eff6ff",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fp-shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 12,
    floodColor: "#1e40af",
    floodOpacity: 0.18
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 48,
    r: 28,
    fill: "#93c5fd",
    fillOpacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 300,
    r: 18,
    fill: "#bfdbfe",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 290,
    r: 12,
    fill: "#ffffff",
    fillOpacity: 0.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 64,
    width: 336,
    height: 220,
    rx: 20,
    fill: "url(#fp-card)",
    filter: "url(#fp-shadow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 88,
    width: 120,
    height: 12,
    rx: 6,
    fill: "#bfdbfe"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 108,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#dbeafe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 200,
    width: 28,
    height: 56,
    rx: 6,
    fill: "#bfdbfe"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 176,
    width: 28,
    height: 80,
    rx: 6,
    fill: "#93c5fd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 152,
    width: 28,
    height: 104,
    rx: 6,
    fill: "url(#fp-grad)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 168,
    width: 28,
    height: 88,
    rx: 6,
    fill: "#3b82f6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 140,
    width: 28,
    height: 116,
    rx: 6,
    fill: "#2563eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 196 L136 172 L176 148 L216 164 L256 136 L288 120",
    stroke: "#1e40af",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 120,
    r: 6,
    fill: "#1e40af",
    stroke: "#fff",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 88,
    width: 92,
    height: 44,
    rx: 10,
    fill: "#ecfdf5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 100,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#6ee7b7"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 112,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#10b981"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 142,
    width: 92,
    height: 44,
    rx: 10,
    fill: "#fef3c7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 154,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#fcd34d"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 166,
    width: 48,
    height: 8,
    rx: 4,
    fill: "#f59e0b"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 168,
    width: 88,
    height: 108,
    rx: 16,
    fill: "url(#fp-grad)",
    filter: "url(#fp-shadow)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 192,
    width: 56,
    height: 36,
    rx: 8,
    fill: "#ffffff",
    fillOpacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 210,
    r: 10,
    fill: "#ffffff",
    fillOpacity: 0.35
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 240,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#ffffff",
    fillOpacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 252,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#ffffff",
    fillOpacity: 0.35
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 228,
    rx: 34,
    ry: 10,
    fill: "#1e3a8a"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 204,
    width: 68,
    height: 24,
    rx: 12,
    fill: "#2563eb"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 204,
    rx: 34,
    ry: 10,
    fill: "#3b82f6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 180,
    width: 68,
    height: 24,
    rx: 12,
    fill: "#60a5fa"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 180,
    rx: 34,
    ry: 10,
    fill: "#93c5fd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 196,
    textAnchor: "middle",
    fill: "#1e40af",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Inter,sans-serif"
  }, "\u20B9")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 248,
    width: 72,
    height: 88,
    rx: 10,
    fill: "#fff",
    filter: "url(#fp-shadow)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 268,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#dbeafe"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 280,
    width: 32,
    height: 5,
    rx: 2.5,
    fill: "#dbeafe"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 300,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "#bfdbfe"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 312,
    width: 36,
    height: 5,
    rx: 2.5,
    fill: "#bfdbfe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356 328 L392 328 L374 348 Z",
    fill: "#1e40af",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceHero);
export default __webpack_public_path__ + "static/media/finance-hero.171c64b5677959921a9bc17a6a65f782.svg";
export { ForwardRef as ReactComponent };